<template>
  <main class="py-1">
    <b-container
      id="f-page"
    >
      <b-row>
        <h1 class="col-12 mb-0 text-center">
          <span>Charte graphique</span>
        </h1>
        <b-col>
          <Logo />

          <Charter />
        </b-col>
      </b-row>
    </b-container>
    <b-container
      id="f-page"
      class="mb-5"
    >
      <b-row>
        <h1
          id="tools"
          class="col-12 mb-0 text-center"
        >
          <span>
            Outils
          </span>
        </h1>
        <b-col>
          <b-tabs content-class="bg-white px-4 py-1 border border-top-0">
            <b-tab
              active
              title="Palette"
            >
              <Colors />
            </b-tab>
            <b-tab title="Icônes">
              <h2 class="mt-4">
                Icônes
              </h2>
              <h3>Icônes génériques (120px et 32px)</h3>
              <ul class="list-inline">
                <li
                  v-for="img in ['violet', 'orange']"
                  :key="img"
                  class="list-inline-item mr-5 my-2"
                >
                  <img
                    alt=""
                    class="mr-5"
                    :src="`${$t('/')}img/apple-${img}.png`"
                    width="120"
                    height="120"
                  />
                  <img
                    alt=""
                    class="mr-5"
                    :src="`${$t('/')}img/favicon-${img}.png`"
                  />
                </li>
              </ul>
              <Generator />
            </b-tab>
            <b-tab title="Bootstrap">
              <Bootstrap />
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-container>
  </main>
</template>

<script>
import Logo from '../../commons/components/graphics/Logo.vue';
import Charter from '../../commons/components/graphics/Charter.vue';

import Colors from '../../commons/components/graphics/Colors.vue';
import Generator from '../../commons/components/graphics/Generator.vue';
import Bootstrap from '../../commons/components/graphics/Bootstrap.vue';

export default {
  components: {
    Logo,
    Charter,
    Colors,
    Generator,
    Bootstrap,
  },
};
</script>

<style lang="scss">
#graphics #f-page {
  .table {
    background: #fff;
  }

  .card.bg-light {
    background: var(--f-g1) !important;
  }

  .alert a {
    color: inherit;
  }
}

#graphics {
  background: linear-gradient(-170deg,#5f2d76,#7dafb6);
  display: table;
  position: absolute;
  width: 100%;

  &::before {
    background:
      var(--f-f8)
      url('../../public/img/bg-sky.jpg')
      no-repeat
      center;
    background-size: cover;
    display: block;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

#f-page {
  background: var(--f-g2);
  border-radius: 1.75rem;
  padding: 1.75rem;
  margin: 5rem auto;
  position: relative;
  z-index: 1;

  h1 {
    margin: -4rem auto 3rem 1rem;
    transform: rotate(-2deg);

    span {
      display: inline-block;
      background: var(--f-o6);
      padding: 1.25rem 1.75rem .5rem;
      border-radius: .5rem;
      color: #fff;
      font-size: 2.4rem;
      @media (min-width: 576px) {
        font-size: 3rem;
      }
      font-family: 'Tovari Sans', sans-serif;
      text-transform: uppercase;
      line-height: 2.5rem;
      font-style: normal;
    }
  }

  h2 {
    color: var(--f-g10);
    font-family: 'Tovari Sans', sans-serif;
    font-size: 2.4rem;
    @media (min-width: 576px) {
      font-size: 3rem;
    }
    line-height: 2.5rem;
    margin-bottom: 1rem;
  }

  .mx-auto.col-lg-9 h2 {
    margin-top: 3rem;
  }
}
</style>
